import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const WebinarAttachmentsApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['webinarAttachments', 'get', webinarId], (api) => api.webinarAttachments.get(webinarId), options),
    edit: (options?: BaseApiMutationOptions<ApiClient['webinarAttachments']['edit']>) => apiMutationOptions((api) => api.webinarAttachments.edit, options),
    remove: (options?: BaseApiMutationOptions<ApiClient['webinarAttachments']['remove']>) => apiMutationOptions((api) => api.webinarAttachments.remove, options)
};
